import React, { useEffect, useRef } from 'react';
import { Header, MenuItemOption } from '../../common_v2/components/Header';
import { Footer } from '../../common_v2/components/Footer';
import { Panel, PanelBorderRadius, PanelTheme, useWaitOverlayStore } from '@apply/components';
import { useParams } from 'react-router';
import { ExperiencePropertyAddress } from './components/ExperiencePropertyAddress/ExperiencePropertyAddress';

import { Lender } from './components/Lender';
import { PropertyTypeInformation } from './components/PropertyTypeInformation/PropertyTypeInformation';
import { ProjectTypeInformation } from './components/ProjectTypeInformation/ProjectTypeInformation';
import { ExperienceButtonPanel } from './components/ExperienceButtonPanel/ExperienceButtonPanel';
import { useGetUserExperienceQuery } from './../queries/userExperienceQueries';
import { CurrentlyOwnPanel } from './components/CurrentlyOwnPanel/CurrentlyOwnPanel';
import { ValidationGroup } from 'devextreme-react/validation-group';
import { isMobileScreen } from '@apply/ui';

export default function ExperiencePropertyPage() {
    const mobileScreen = isMobileScreen();
    const validationGroupRef = useRef(null);
    const { setWaiting } = useWaitOverlayStore.getState();
    const { experienceId } = useParams<{ experienceId?: string }>();
    const numericExperienceId = experienceId ? Number(experienceId) : undefined;
    const isEditMode = experienceId != null;
    const isValidId = numericExperienceId != null && !Number.isNaN(numericExperienceId);

    const { isLoading } = useGetUserExperienceQuery(isEditMode && isValidId ? numericExperienceId : undefined);

    useEffect(() => {
        if (isLoading) {
            setWaiting(true, 'Loading Your Experience...');
        } else {
            setWaiting(false);
        }
    }, [isLoading]);

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.Experience} />
                <main>
                    <ValidationGroup ref={validationGroupRef}>
                        <div
                            style={{
                                width: mobileScreen ? '96%' : '60%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        >
                            <div className='experience-property'>
                                <h2
                                    style={{
                                        paddingTop: mobileScreen ? '2rem' : 0,
                                        paddingLeft: mobileScreen ? '1rem' : 0,
                                    }}
                                >
                                    {!isEditMode ? 'Add Experience' : `Edit Experience`}
                                </h2>
                                <div style={{ paddingTop: '1rem' }}>
                                    <Panel
                                        theme={PanelTheme.White}
                                        borderRadius={PanelBorderRadius.Medium}
                                    >
                                        <div
                                            style={{
                                                width: mobileScreen ? '95%' : '85%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto',
                                            }}
                                        >
                                            <ProjectTypeInformation experienceId={experienceId} />
                                            <br />
                                            <br />
                                            <h4>Property Info</h4>
                                            <ExperiencePropertyAddress
                                                experienceId={experienceId}
                                                required={true}
                                            />
                                            <PropertyTypeInformation experienceId={experienceId} />
                                            <br />
                                            <CurrentlyOwnPanel experienceId={experienceId} />
                                            <Lender
                                                experienceId={experienceId}
                                                required={false}
                                            />
                                            <ExperienceButtonPanel
                                                experienceId={experienceId}
                                                validationGroupRef={validationGroupRef}
                                            />
                                        </div>
                                    </Panel>
                                </div>
                            </div>
                        </div>
                    </ValidationGroup>
                </main>
            </div>
            <Footer />
        </>
    );
}
